export const FIND_REF_RESULTS_FAILURE = 'FIND_REF_RESULTS_FAILURE';

export const findRefResultsFailure = error => ({
    type: FIND_REF_RESULTS_FAILURE,
    payload: error,
    error: true,
});
